const Header = {
  init() {
    Header.events();
  },

  /**
   * Events
   */
  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });

    // Toggle open menu.
    $(".toggle-open-menu").on("click", (e) => {

      $(".open-menu").toggleClass("menu-visible");
      if( $(".screen-overlay").hasClass("menu-visible") ){
        $(".screen-overlay").removeClass("menu-visible")
      } else {
        $(".screen-overlay").addClass("menu-visible")
      }

    });
  },

  /**
   * Add class on scroll
   */
  scroll() {
    const st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },
};

export default Header;
